export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DelegationModal.vue?vue&type=template&id=5819e5e5&"


//////////////////
// WEBPACK FOOTER
// ./src/components/DelegationModal.vue?vue&type=template&id=5819e5e5&
// module id = 548
// module chunks = 0